import { PRODUCTS_STORE_KEY } from '../constants';
import type { State as ProductsState } from '../reducers/product';

export default (state: GlobalState) => state[PRODUCTS_STORE_KEY] as ProductsState;
